var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTeachers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm7.601 4.241l-4-3A1.244 1.244 0 0010.857 6H5.143c-.273 0-.537.086-.744.241l-4 3c-.12.09-.217.2-.285.324a.89.89 0 00-.035.8 1 1 0 00.256.342l3.093 2.707v-2.828l-.604-.529L4.57 8.746V15c0 .265.12.52.335.707.214.188.505.293.808.293h4.572c.303 0 .594-.105.808-.293a.941.941 0 00.335-.707V8.746l1.747 1.311-.604.529v2.828l3.093-2.707a1 1 0 00.256-.342.89.89 0 00-.035-.8 1.03 1.03 0 00-.285-.324z",
    fill: "#797584"
  })));
}

export default SvgTeachers;